import { render, staticRenderFns } from "./permissions-user.vue?vue&type=template&id=6d869254&"
import script from "./permissions-user.vue?vue&type=script&lang=js&"
export * from "./permissions-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports